<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		findConpanyConfig
	} from '../../../../../../api/Draftgeneration.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				// tableDataI: getdata().tableDataI,
				delCells: [],
			};
		},
		props: {
			params: {
				type: Object,
				default: {}
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: []
			},
			optionxfs: {
				type: Array,
				default: []
			},
			headobj: {
				type: Object,
				default: {}
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			changeXfs(e, ve, index) {
				optionxdansha(this.optionxfs)

				function optionxdansha(data) {
					ve['xfs_1_x_0'].cellType = '1'
					data.forEach(item => {
						if (item.value == e) {
							if (item.type == '1') {
								ve['xfs_1_x_10'].cellVal = (parseFloat(item.shuil) * 100).toFixed(2)
								ve['xfs_1_x_16'].cellVal = '0'
								ve['xfs_1_x_17'].cellVal = ''
							} else if (item.type == '2') {
								ve['xfs_1_x_16'].cellVal = (item.shuil).toString()
								ve['xfs_1_x_10'].cellVal = '0'
								ve['xfs_1_x_17'].cellVal = item.jldw
							}
						} else {
							if (item.children) {
								optionxdansha(item.children)
							}
						}
					})
				}
				this.$emit('forhover', 'tableDataII_I', 'xfs_1_x_10', index);
				this.$emit('inputblur', ve['xfs_1_x_10']);
				this.$emit('forhover', 'tableDataII_I', 'xfs_1_x_16', index);
				this.$emit('inputblur', ve['xfs_1_x_16']);
				this.$emit('forhover', 'tableDataII_I', 'xfs_1_x_0', index);
			},
			headchange() {
				this.$emit('headchange', this.headobj);
			},
			inputblur(e) {
				this.$emit('inputblur', e);
			},
			forhover(table, colum, index) {
				this.$emit('forhover', table, colum, index);
			},
			zcsclick(e) {
				this.$emit('zcsclick', e);
			},
			fordelete(index) {
				if (this.tableDataI.length < 3) {
					return false;
				}
				if (this.$notemptyandnull(this.tableDataI[index]['xfs_1_x_1'].id)) {
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
				}
				this.tableDataI.splice(index, 1);
				this.$emit('delCellsCode', this.delCells, 'IIHead');
			},
			foraddhang() {
				let hanh = this.tableDataI.length - 1
				this.tableDataI.splice(this.tableDataI.length - 1, 0, {
					hanh: hanh,
					"xfs_1_x_0": {
						cellCode: "xfs_1_" + hanh + "_0",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_1": {
						cellCode: "xfs_1_" + hanh + "_1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_2": {
						cellCode: "xfs_1_" + hanh + "_2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_3": {
						cellCode: "xfs_1_" + hanh + "_3",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_4": {
						cellCode: "xfs_1_" + hanh + "_4",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_5": {
						cellCode: "xfs_1_" + hanh + "_5",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_6": {
						cellCode: "xfs_1_" + hanh + "_6",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_7": {
						cellCode: "xfs_1_" + hanh + "_7",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_8": {
						cellCode: "xfs_1_" + hanh + "_8",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_9": {
						cellCode: "xfs_1_" + hanh + "_9",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_10": {
						cellCode: "xfs_1_" + hanh + "_10",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_11": {
						cellCode: "xfs_1_" + hanh + "_11",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_12": {
						cellCode: "xfs_1_" + hanh + "_12",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_13": {
						cellCode: "xfs_1_" + hanh + "_13",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_14": {
						cellCode: "xfs_1_" + hanh + "_14",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_15": {
						cellCode: "xfs_1_" + hanh + "_15",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_16": {
						cellCode: "xfs_1_" + hanh + "_16",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_17": {
						cellCode: "xfs_1_" + hanh + "_17",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_18": {
						cellCode: "xfs_1_" + hanh + "_18",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_1_x_19": {
						cellCode: "xfs_1_" + hanh + "_19",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
				})
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>